









import VueOptions from '@utils/VueOptions'
import VenueResourceList from '@hostComponents/Venue/VenueResourceList'

settings =
  name: 'VenueList'

  resources:
    venues:
      resourceName: 'venue'
      slug: 'suppliers/:supplierId/venues'
      infinityScroll: true

  vue:
    components: {
      VenueResourceList,
    }

    computed:
      member: -> @$store.member
      supplierId: -> @member.supplier.id

      actionsForVenues: ->
        fetchResource: @fetchResource

    methods:
      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity state, resourceKey, data, options

export default VueOptions.vue settings
